<template>
    <div class="tooltip" @mouseenter="showTooltip" @mouseleave="hideTooltip">
        <slot></slot>
        <div v-if="isTooltipVisible" class="tooltip-text">
            {{ content }}
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            isTooltipVisible: false,
        };
    },
    props: {
        content: {
            type: String,
            required: true,
        },
    },
    methods: {
        showTooltip() {
            this.isTooltipVisible = true;
        },
        hideTooltip() {
            this.isTooltipVisible = false;
        },
    },
};
</script>
  
<style lang="scss" scoped>
@import "@/public/scss/common/tooltip/index.scss";
</style>
  